import { useContext } from 'react';
import { SystemContext } from '../System';
import { TokenStore } from '../stores/TokenStore';

export function useTokenStore(): TokenStore {
  const system = useContext(SystemContext);
  return system.tokenStore;
}
